import React from "react";
import { motion } from "framer-motion";
import { Settings, Save } from "@mui/icons-material";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";

const SiteSettingsHeader = ({ handleSaveSettings, saving }) => {
  return (
    <div className="bg-primary text-white py-4 mb-4">
      <Container>
        <Row className="align-items-center">
          <Col>
            <motion.h2
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
              className="mb-1"
            >
              <Settings className="me-2" /> Site Ayarları
            </motion.h2>
            <motion.p
              initial={{ y: -10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="mb-0 text-white-50"
            >
              Sistem genelinde kullanılan genel ayarları bu sayfadan yönetebilirsiniz
            </motion.p>
          </Col>
          <Col xs="auto">
            <Button
              variant="light"
              className="d-flex align-items-center"
              onClick={() => handleSaveSettings()}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Kaydediliyor...
                </>
              ) : (
                <>
                  <Save className="me-2" />
                  Tüm Değişiklikleri Kaydet
                </>
              )}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SiteSettingsHeader;
